import React from 'react';
import styles from '../../publicationDetail.module.scss';
import { images } from '../../../../constants/images';
import Button from '../../../Button';
import { PublicationPromoBannersProps } from '../../interfaces';

const PublicationPromoBanners: React.FC<PublicationPromoBannersProps> = ({
    type,
    vehicleTypeSelected,
    onLinzeCheckClick,
    onAutoFinClick,
    disabled
}) => {
    return (
        <>
            {type === "myPublication" && vehicleTypeSelected !== "new" && (
                <div
                    className={`${styles.imageSectionPublication} ${disabled ? styles.imageSectionDisabled : ""}`}
                    onClick={disabled ? undefined : onLinzeCheckClick}
                    style={disabled ? { cursor: 'not-allowed', opacity: 0.5 } : {}}
                >
                    <img
                        src={images.autoIcar}
                        alt="Descripción de la imagen"
                        className={styles.promoImage}
                        style={disabled ? { filter: 'grayscale(100%)' } : {}}
                    />
                    <p className={styles.overlayPublication}>
                        <p className={styles.overlayTitle}>icar</p>
                        <p className={styles.overlayText}>Adquiere el informe técnico del vehículo</p>
                        <Button
                            title="Solicitar Informe"
                            onPress={disabled ? undefined : onLinzeCheckClick}
                            tertiary
                            size='small'
                            className={`${styles.btnInformeOverlay} ${styles.customButtonOverlay}`}
                            disabled={disabled}
                        />
                    </p>
                </div>
            )}

            {type !== "myPublication" && vehicleTypeSelected === "used" && (
                <div
                    className={`${styles.imageSection} ${disabled ? styles.imageSectionDisabled : ""}`}
                    onClick={disabled ? undefined : onLinzeCheckClick}
                    style={disabled ? { cursor: 'not-allowed', opacity: 0.5 } : {}}
                >
                    <img
                        src={images.autoIcar}
                        alt="Descripción de la imagen"
                        className={styles.promoImage}
                        style={disabled ? { filter: 'grayscale(100%)' } : {}}
                    />
                    <p className={styles.overlay}>
                        <p className={styles.overlayTitle}>icar</p>
                        <p className={styles.overlayText}>Adquiere el informe técnico del vehículo</p>
                        <Button
                            title="Solicitar Informe"
                            onPress={disabled ? undefined : onLinzeCheckClick}
                            tertiary
                            size='small'
                            className={`${styles.btnInformeOverlay} ${styles.customButtonOverlay}`}
                            disabled={disabled}
                        />
                    </p>
                </div>
            )}

            {type === "myPublication" && vehicleTypeSelected === "new" && (
                <div className={styles.imageSectionAutoFin} onClick={onAutoFinClick}>
                    <img
                        src={images.calculadoraBannerCredito}
                        alt=""
                        className={styles.promoImage}
                    />
                    <p className={styles.overlayAutoFin}>
                        <p className={styles.overlayTitleAutoFin}>Calcula tu crédito</p>
                        <p className={styles.overlayTextAutoFin}>Calcula las cuotas para financiar tu nuevo auto</p>
                    </p>
                </div>
            )}

            {type === "salePost" && (
                <div
                    className={`${styles.imageSection} ${styles.disabled}`}
                    onClick={(e) => e.preventDefault()}
                >
                    <img
                        src={images.autoIcar}
                        alt="Descripción de la imagen"
                        className={styles.promoImage}
                    />
                    <div className={styles.overlay}>
                        <p className={styles.overlayTitle}>icar</p>
                        <p className={styles.overlayText}>Adquiere el informe técnico del vehículo</p>
                        <Button
                            title="Solicitar Informe"
                            onPress={undefined}
                            tertiary
                            size='small'
                            disabled
                            className={`${styles.btnInformeOverlay} ${styles.customButtonOverlay}`}
                        />
                    </div>
                </div>
            )}
        </>
    );
};

export default PublicationPromoBanners;
